import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import styled from 'styled-components';
import logoImg from '../assets/logo-godaiStudios.png';

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f9f9f9;
`;

const LogoImage = styled.img`
  height: 80px;
  width: auto;
  margin-bottom: 30px;
`;

const LoadingText = styled.div`
  font-size: 18px;
  color: #666;
  margin-top: 20px;
`;

const PrivateRoute = () => {
  const { isAuthenticated, loading, isAdmin } = useAuth();
  const location = useLocation();
  
  if (loading) {
    return (
      <LoadingContainer>
        <LogoImage src={logoImg} alt="Godai Studios Logo" />
        <LoadingText>Loading...</LoadingText>
      </LoadingContainer>
    );
  }
  
  if (!isAuthenticated) {
    // Redirect to login page, but save the location they were trying to access
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  // Check if user is an admin
  if (!isAdmin()) {
    // User is authenticated but not an admin
    return <Navigate to="/login" state={{ accessDenied: true }} replace />;
  }
  
  // User is authenticated and is an admin, render the protected routes
  return <Outlet />;
};

export default PrivateRoute; 